import React from "react";
import Image from "components/image";
import useKlaviyoSubscription from "hooks/useKlaviyoSubscription";
import Input from "components/input";
import clsx from "clsx/lite";
import SmsSignUpForm from "components/sms-subscription/form";
import { useSettings } from "hooks/useStore";

const Newsletter = ({ data, className }) => {
	const { success, error, email, handleSubscribe, onChange } = useKlaviyoSubscription(data.formId);
	const { klaviyoEmail, updateKlaviyoEmail } = useSettings(["klaviyoEmail","updateKlaviyoEmail"]);

	const handleEmailSubmit = async (e) => {
		e.preventDefault();

		const res = await handleSubscribe(e, { email });
		if (res?.success) {
			updateKlaviyoEmail(email);
		}
	};

	return (
		<div
			className={clsx( className, "w-full flex justify-center px-0 md:px-4 xl:px-5 standard-section-width mx-auto", 
				klaviyoEmail ? "min-h-128" : "min-h-full")}>
			<div className="w-full flex standard-section-width bg-black relative">
				<div className="flex flex-col px-4 py-12 md:px-10 gap-3 max-w-full absolute md:relative z-10 w-full
									bg-gradient-to-r from-black via-opacity-30 lg:w-1/2 h-full">
					{!klaviyoEmail ? (
						<>
							<div className="flex flex-col gap-2">
								<h2 className="text-white">{data.title}</h2>
								<p className="text-sm text-white">{data.subtitle}</p>
							</div>
							<form onSubmit={handleEmailSubmit} className="flex gap-4 flex-col lg:flex-row" 
								onChange={(e) => onChange(e.target.value)} >
								<Input placeholder="user@example.com" label="Your Email" name="email" type="email" value={email} 
									error={error} className="w-full  text-black"/>
								<button className="btn-secondary w-full sm:w-fit hover:text-black hover:bg-beige"> Join </button>
							</form>
						</>
					) : (
						<SmsSignUpForm
							data={{ title: "Now one more step!", 
								description: "Get instant updates and exclusive offers — sign up for SMS now!",
								id: data.smsFormId,
							}}
							emailSuccess={success} isSecondStep />
					)}
				</div>
				<Image image={data.desktopImage} className="!hidden md:!block w-1/2 h-auto max-h-full object-cover" />
				<Image image={data.mobileImage} className="md:!hidden h-auto max-h-full object-cover" />
			</div>
		</div>
	);
};

export default Newsletter;